import { request, Rows } from './request';
import AppError from './models/common/res/AppError';

export interface TreatmentCategoryDto {
  // 데이터 ID(PK)
  id: number;
  // 생성일시
  createdAt: string;
  // 수정일시
  updatedAt: string;
  // 진료 카테고리명
  name: string;
  // 진료 카테고리 설명
  description: string;
  // 노출여부
  viewable: boolean;
  // 가중치
  weight: number;
  // 2차 진료분야 목록
  childTreatmentCategories: ChildTreatmentCategoryDto[];
}

export interface ChildTreatmentCategoryDto {
  // 데이터 ID(PK)
  id: number;
  // 생성일시
  createdAt: string;
  // 수정일시
  updatedAt: string;
  // 진료 카테고리명
  name: string;
  // 진료 카테고리 설명
  description: string;
  // 노출여부
  viewable: boolean;
  // 가중치
  weight: number;
}

export const fetchTreatmentCategories = async (params: {
  languageCode?: string;
  partnerCode: string;
  isCustom?: boolean;
}) => {
  const url = `/treatment-categories/${params.partnerCode}`;

  try {
    const { data } = await request<Rows<TreatmentCategoryDto>>({
      method: 'get',
      url,
      queryParams: {
        languageCode: params.languageCode,
        isCustom: params.isCustom,
      },
    });

    const { rows } = data;
    return rows;
  } catch (e) {
    return [];
  }
};
